import React from 'react'

export default function PageNotFound() {
  return (
    <div className='h-screen w-full flex justify-center items-center align-middle text-5xl bg-slate-900 text-slate-500'>Page Not Found</div>
  )
}
